var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8V19C3.5 21.201 5.294 22 6.5 22H21.5V20H6.512C6.05 19.988 5.5 19.806 5.5 19C5.5 18.194 6.05 18.012 6.512 18H21.5V4C21.5 2.897 20.603 2 19.5 2H6.5C5.294 2 3.5 2.799 3.5 5V8ZM20.5 4H19.5V16H5.5H20C20 15.194 20.05 4.012 20.5 4Z",
    fill: "#11B55F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.497 14L15.847 10.711C16.0535 10.5124 16.2178 10.2741 16.3301 10.0104C16.4423 9.7467 16.5002 9.46308 16.5002 9.1765C16.5002 8.88993 16.4423 8.60631 16.3301 8.34263C16.2178 8.07895 16.0535 7.84065 15.847 7.642C15.4306 7.23101 14.869 7.00056 14.284 7.00056C13.6989 7.00056 13.1374 7.23101 12.721 7.642L12.497 7.86L12.273 7.641C11.8567 7.23007 11.2954 6.99965 10.7105 6.99965C10.1256 6.99965 9.56419 7.23007 9.14796 7.641C8.94141 7.83965 8.77709 8.07795 8.66485 8.34163C8.55261 8.60531 8.49475 8.88893 8.49475 9.1755C8.49475 9.46207 8.55261 9.7457 8.66485 10.0094C8.77709 10.2731 8.94141 10.5114 9.14796 10.71L12.497 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon2);
export default __webpack_public_path__ + "static/media/shareIcon2.cc756360f189e1f70e2bfdef839c0e97.svg";
export { ForwardRef as ReactComponent };